<div class="no-data-wrapper">
  <div class="no-data-card">

    <img src="/assets/nodata.png" class="no-data-img" />

    <p class="no-data-text">
      {{ "No data available" | transloco }}
    </p>

  </div>
</div>